import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const debitNoteListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    let merchant_ids = '';
    if (payload?.merchant_id?.length > 0) {
        merchant_ids = payload.merchant_id.map(id => `filter[merchants][]=${encodeURIComponent(id)}`).join('&');
    }
    try {
        const response = await fetch(
            `${server}debit-notes?search=${payload?.search || ''}&sort_order=${payload?.sort}&paginate=${payload?.page}&size=${payload?.size || ''}&sort=${payload?.sort_by || ''}&filter[amount_min]=${payload?.amount_min || ''}&filter[amount_max]=${payload?.amount_max || ''}${merchant_ids ? `&${merchant_ids}` : ''}&filter[date_range]=${payload?.dateRangeType || ''}&filter[from]=${payload?.startDate || ''}&filter[to]=${payload?.endDate || ''}&filter[type]=${payload?.type || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const debitNoteDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}debit-notes/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const debitNoteExportApi = async (payload) => {
    const request = requestAuthOption("POST")
    let merchant_ids = '';
    if (payload?.merchant_id?.length > 0) {
        merchant_ids = payload.merchant_id.map(id => `filter[merchants][]=${encodeURIComponent(id)}`).join('&');
    }
    try {
        const response = await fetch(
            // `${server}compaigns?search=${payload?.search || ''}`,
            `${server}debit-notes/export?search=${payload?.search || ''}&sort_order=${payload?.sort}&sort=${payload?.sort_by || ''}&filter[amount_min]=${payload?.amount_min || ''}&filter[amount_max]=${payload?.amount_max || ''}${merchant_ids ? `&${merchant_ids}` : ''}&filter[date_range]=${payload?.dateRangeType || ''}&filter[from]=${payload?.startDate || ''}&filter[to]=${payload?.endDate || ''}&filter[type]=${payload?.type || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};